/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Side_info_QueryVariables = {
    side: string;
};
export type Side_info_QueryResponse = {
    readonly pages: ReadonlyArray<{
        readonly title: string;
        readonly slug: string;
        readonly id: string;
    } | null> | null;
    readonly page: {
        readonly " $fragmentRefs": FragmentRefs<"PageView_page" | "metadata_metadata">;
    } | null;
};
export type Side_info_Query = {
    readonly response: Side_info_QueryResponse;
    readonly variables: Side_info_QueryVariables;
};



/*
query Side_info_Query(
  $side: String!
) {
  pages(infopage: true) {
    title
    slug
    id
  }
  page(slug: $side) {
    ...PageView_page
    ...metadata_metadata
    id
  }
}

fragment PageView_page on Page {
  id
  content
  slug
  title
  dateSaved
  dateCreated
  videoFile
}

fragment metadata_metadata on OpengraphMetadata {
  __isOpengraphMetadata: __typename
  title
  description
  sharingImage
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "side"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "infopage",
      "value": true
    }
  ],
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "pages",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": "pages(infopage:true)"
},
v5 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "side"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Side_info_Query",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PageView_page"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "metadata_metadata"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Side_info_Query",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          (v2/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateSaved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoFile",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sharingImage",
                "storageKey": null
              }
            ],
            "type": "OpengraphMetadata",
            "abstractKey": "__isOpengraphMetadata"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01f0b852e395ddba63a93f6c5fb85fa3",
    "id": null,
    "metadata": {},
    "name": "Side_info_Query",
    "operationKind": "query",
    "text": "query Side_info_Query(\n  $side: String!\n) {\n  pages(infopage: true) {\n    title\n    slug\n    id\n  }\n  page(slug: $side) {\n    ...PageView_page\n    ...metadata_metadata\n    id\n  }\n}\n\nfragment PageView_page on Page {\n  id\n  content\n  slug\n  title\n  dateSaved\n  dateCreated\n  videoFile\n}\n\nfragment metadata_metadata on OpengraphMetadata {\n  __isOpengraphMetadata: __typename\n  title\n  description\n  sharingImage\n}\n"
  }
};
})();
(node as any).hash = 'aaf47299f6fe9c597e771d723426e0e9';
export default node;
